import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface EditSquareIconProps extends SvgIconProps {}

export const EditSquareIcon = (props: EditSquareIconProps): ReactElement => {
  return (
    <SvgIcon {...props} viewBox="0 0 30 30">
      <mask
        id="mask0_1757_4536"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1757_4536)">
        <path
          d="M7.01937 25.0001C6.44396 25.0001 5.96354 24.8074 5.57812 24.4219C5.19271 24.0365 5 23.5561 5 22.9807V7.01943C5 6.44402 5.19271 5.9636 5.57812 5.57818C5.96354 5.19277 6.44396 5.00006 7.01937 5.00006H17.5025L16.2525 6.25006H7.01937C6.82687 6.25006 6.65052 6.33016 6.49031 6.49037C6.3301 6.65058 6.25 6.82693 6.25 7.01943V22.9807C6.25 23.1732 6.3301 23.3495 6.49031 23.5097C6.65052 23.67 6.82687 23.7501 7.01937 23.7501H22.9806C23.1731 23.7501 23.3495 23.67 23.5097 23.5097C23.6699 23.3495 23.75 23.1732 23.75 22.9807V13.6204L25 12.3704V22.9807C25 23.5561 24.8073 24.0365 24.4219 24.4219C24.0365 24.8074 23.556 25.0001 22.9806 25.0001H7.01937ZM12.5 17.5001V14.2307L23.6803 3.05068C23.818 2.91277 23.963 2.81735 24.1153 2.76443C24.2676 2.71152 24.4279 2.68506 24.5963 2.68506C24.7533 2.68506 24.9068 2.71152 25.0566 2.76443C25.2064 2.81735 25.3422 2.90475 25.4641 3.02662L26.8534 4.37506C26.9864 4.51298 27.0873 4.66485 27.1562 4.83068C27.2252 4.99652 27.2597 5.1636 27.2597 5.33193C27.2597 5.50006 27.2344 5.65902 27.1838 5.80881C27.1333 5.95881 27.0393 6.10266 26.9016 6.24037L15.6491 17.5001H12.5ZM13.75 16.2501H15.1153L23.4472 7.91818L22.7644 7.23568L22.0025 6.50475L13.75 14.7572V16.2501Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
